import React, { useState } from "react";
import { Container, Grid } from "@mui/material";
import ReviewData from "../../Components/ReviewData";
import { useSelector } from "react-redux";
import CrossingTradeRebalancer from "../../Popup/CrossingTradeRebalancer";
import { selectSleeveDataStageOne } from "../../../../Redux/Reducers/selectors";

const FundStep2 = ({ setCurrentStep, sleeve, driftValue,rebalanceType,rebalancedFunds,rebalancedStrategies,deltaRebalancer }) => {
  
  const sleeveDataStageOne = useSelector(selectSleeveDataStageOne);
  const [existingNewArray, setExistingNewArray] = useState({});
  const [openCrossPopup, setOpenCrossPopup] = useState(false);
  const [onceClicked, setOnceClicked] = useState(false);
  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
              }}
            >
              <ReviewData
                sleeve={sleeve}
                setExistingNewArray={setExistingNewArray}
                existingNewArray={existingNewArray}
                sleeveDataStageOne={sleeveDataStageOne}
                setOpenCrossPopup={setOpenCrossPopup}
                setOnceClicked={setOnceClicked}
                onceClicked={onceClicked}
                showNext={true}
                driftValue={driftValue}
                rebalanceType={rebalanceType}
                rebalancedFunds={rebalancedFunds}
                rebalancedStrategies={rebalancedStrategies}
                deltaRebalancer={deltaRebalancer}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <CrossingTradeRebalancer
        title="Orders"
        openCrossPopup={openCrossPopup}
        setOpenCrossPopup={setOpenCrossPopup}
        setCurrentStep={setCurrentStep}
        showNext={true}
        rebalanceType={rebalanceType}
        rebalancedFunds={rebalancedFunds}
      />
    </Container>
  );
};

export default FundStep2;
